import request from '../utils/request'

const prefix = '/api/v1/back'

/**
 * 内容&实体资料部分
 *
 */


/**
 * 实体资料查询：列表
 * @param {*} query
 */
export const materialList = (query) => {
  return request({
    url: `${prefix}/material/list`,
    method: 'get',
    params: query
  })
}

/**
 * 实体资料查询
 * @param {*} query
 */
export const materialOne = (query) => {
  return request({
    url: `${prefix}/material`,
    method: 'get',
    params: query
  })
}

/**
 * 实体资料创建
 * @param {*} query
 */
export const materialCreate = (query) => {
  return request({
    url: `${prefix}/material`,
    method: 'post',
    data: query
  })
}

/**
 * 实体资料修改
 * @param {*} query
 */
export const materialUpdate = (query) => {
  return request({
    url: `${prefix}/material`,
    method: 'put',
    data: query
  })
}

/**
 * 实体资料修改 多行
 * @param {*} query
 */
export const materialsUpdate = (query) => {
  return request({
    url: `${prefix}/materials`,
    method: 'put',
    data: query
  })
}

/**
 * 实体资料修改状态
 * @param {*} query
 */
export const materialUpdateStatus = (query) => {
  return request({
    url: `${prefix}/material/status`,
    method: 'put',
    data: query
  })
}

/**
 * 实体资料删除
 * @param {*} query
 */
export const materialDestroy = (query) => {
  return request({
    url: `${prefix}/material`,
    method: 'delete',
    data: query
  })
}

/**
 * 实体资料删除 真
 * @param {*} query
 */
export const materialRemove = (query) => {
  return request({
    url: `${prefix}/material/remove`,
    method: 'delete',
    data: query
  })
}

/**
 * 实体资料恢复
 * @param {*} query
 */
export const materialRestore = (query) => {
  return request({
    url: `${prefix}/material/restore`,
    method: 'post',
    data: query
  })
}

/**
 * 实体资料克隆
 * @param {*} query
 */
export const materialClone = (query) => {
  return request({
    url: `${prefix}/material/clone`,
    method: 'post',
    data: query
  })
}


/**
 * 资料分类（创建资料分类）
 * @param {*} query
 */
export const addmaterialcategory = (query) => {
  return request({
    url: `${prefix}/material/category`,
    method: 'post',
    data: query
  })
}



/**
 * 资料分类（修改资料分类）
 * @param {*} query
 */
export const editmaterialcategory = (query) => {
  return request({
    url: `${prefix}/material/category`,
    method: 'put',
    data: query
  })
}



/**
 * 资料分类（删除资料分类）
 * @param {*} query
 */
export const deletematerialcategory = (query) => {
  return request({
    url: `${prefix}/material/category`,
    method: 'delete',
    data: query
  })
}


/**
 * 资料分类（查询列表）
 * @param {*} query
 */
export const materialcategorylist = (query) => {
  return request({
    url: `${prefix}/material/category/list`,
    method: 'get',
    params: query
  })
}